import Client from 'modules/Client'

export default {
  fetchAll (params) {
    return Client.get('api/aluno/alerta', { params })
  },

  read (id) {
    return Client.put(`api/aluno/alerta/${id}`)
  }
}
